import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, renderList as _renderList } from "vue";
const _hoisted_1 = {
  key: 1,
  class: "menu-svg-container"
};
const _hoisted_2 = {
  key: 1,
  class: "menu-svg-container"
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  key: 1,
  class: "menu-svg-container"
};
const _hoisted_5 = {
  key: 1
};
import path from 'path-browserify';
import { isExternal } from '@/utils/validate';
import { ref, toRefs } from 'vue';
// import Badge from '@/components/Badge/index.vue'
export default /*@__PURE__*/_defineComponent({
  __name: 'SidebarItem',
  props: {
    item: {},
    isNest: {
      type: Boolean
    },
    basePath: {}
  },
  setup(__props) {
    const prop = __props;
    const {
      item,
      isNest,
      basePath
    } = toRefs(prop);
    const onlyOneChild = ref();
    const hasOneShowingChild = (children = [], parent) => {
      const showingChildren = children.filter(item => {
        if (item.hidden) {
          return false;
        } else {
          // Temp set(will be used if only has one showing child)
          onlyOneChild.value = item;
          return true;
        }
      });
      // When there is only one child router, the child router is displayed by default
      if (showingChildren.length === 1) {
        return true;
      }
      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        onlyOneChild.value = {
          ...parent,
          path: '',
          noShowingChildren: true
        };
        return true;
      }
      return false;
    };
    function resolvePath(routePath) {
      if (isExternal(routePath)) {
        return routePath;
      }
      if (isExternal(basePath.value)) {
        return basePath.value;
      }
      return path.resolve(basePath.value, routePath);
    }
    return (_ctx, _cache) => {
      const _component_x_icon = _resolveComponent("x-icon");
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_el_menu_item = _resolveComponent("el-menu-item");
      const _component_sidebar_item = _resolveComponent("sidebar-item", true);
      const _component_el_sub_menu = _resolveComponent("el-sub-menu");
      return !_unref(item).meta?.hidden && hasOneShowingChild(_unref(item).children, _unref(item)) && (!onlyOneChild.value.children || onlyOneChild.value.noShowingChildren) && !_unref(item).meta?.alwaysShow && onlyOneChild.value.meta ? (_openBlock(), _createBlock(_component_el_menu_item, {
        key: 0,
        index: resolvePath(onlyOneChild.value.path),
        class: _normalizeClass({
          'submenu-title-noDropdown': !_unref(isNest)
        })
      }, {
        title: _withCtx(() => [onlyOneChild.value.meta && onlyOneChild.value.meta.title ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(onlyOneChild.value.meta.title), 1)) : _createCommentVNode("", true)]),
        default: _withCtx(() => [onlyOneChild.value.meta.icon ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [onlyOneChild.value.meta.icon.includes('el-icon') ? (_openBlock(), _createBlock(_component_x_icon, {
          key: 0,
          class: "menu-item-icon menu-icon",
          icon: onlyOneChild.value.meta.icon
        }, null, 8, ["icon"])) : (_openBlock(), _createElementBlock("i", _hoisted_1, [_createVNode(_component_svg_icon, {
          class: "menu-svg-icon",
          "icon-class": onlyOneChild.value.meta.icon
        }, null, 8, ["icon-class"])]))], 64)) : _unref(item).meta && _unref(item).meta.icon ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_unref(item).meta.icon.includes('el-icon') ? (_openBlock(), _createBlock(_component_x_icon, {
          key: 0,
          class: "menu-item-icon menu-icon",
          icon: _unref(item).meta.icon
        }, null, 8, ["icon"])) : (_openBlock(), _createElementBlock("i", _hoisted_2, [_createVNode(_component_svg_icon, {
          class: "menu-svg-icon",
          "icon-class": _unref(item).meta.icon
        }, null, 8, ["icon-class"])]))], 64)) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["index", "class"])) : _unref(item).meta && !_unref(item).meta?.hidden ? (_openBlock(), _createBlock(_component_el_sub_menu, {
        key: 1,
        index: resolvePath(_unref(item).path),
        teleported: ""
      }, {
        title: _withCtx(() => [_unref(item).meta && _unref(item).meta.icon ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_unref(item).meta.icon.includes('el-icon') ? (_openBlock(), _createBlock(_component_x_icon, {
          key: 0,
          class: "sub-menu-icon menu-icon",
          icon: _unref(item).meta.icon
        }, null, 8, ["icon"])) : (_openBlock(), _createElementBlock("i", _hoisted_4, [_createVNode(_component_svg_icon, {
          class: "menu-svg-icon",
          "icon-class": _unref(item).meta.icon
        }, null, 8, ["icon-class"])]))], 64)) : _createCommentVNode("", true), _unref(item).meta && _unref(item).meta.title ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(item).meta.title), 1)) : _createCommentVNode("", true)]),
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(item).children, child => {
          return _openBlock(), _createBlock(_component_sidebar_item, {
            key: child.path,
            "is-nest": true,
            item: child,
            "base-path": resolvePath(child.path),
            class: "nest-menu"
          }, null, 8, ["item", "base-path"]);
        }), 128))]),
        _: 1
      }, 8, ["index"])) : _createCommentVNode("", true);
    };
  }
});